import { Form } from "./Form";

export class RequestDemoForm extends Form {


  constructor(formEl, emailType, selectedProducts, gaCategoryType, gaEventType, cb) {
    super(formEl, emailType, gaCategoryType, gaEventType);
    this.selectedProducts = selectedProducts;
    this.showConfirmationEl = cb;
  }

  init() {
    super.init();
  }

  prepareFormData() {
    this.prepareSelectBoxData();

    this.formEl.querySelectorAll('.contact-form__field').forEach(({ name, value, type }) => {
      if (type === 'checkbox') {
        return;
      }

      this.formData.append(
        ['company', 'phone', 'language'].some(inputName => inputName === name) ? `additionalParameters.${ name }` : name,
        value
      );
    });

    for (let i = 0; i < this.selectedProducts.length; i++) {
      if (this.selectedProducts[i]) {
        this.formData.append('products', this.selectedProducts[i]);
      }

    }
  }

  afterFormSendTracking() {
    if(window.lintrk) {
      window.lintrk('track', { conversion_id: 8350641 });
    }

    if (this.afterFormSend && typeof this.afterFormSend === 'function') {
      this.afterFormSend();
    }
  }


  showNotification(isEmailUse) {
    if(!isEmailUse) {
      this.showConfirmationEl(this.formData.get('senderEmail'));
      this.formEl.reset();
      const selectBoxParagraph = document.querySelector('.select-box__value .select-box__input-text');

      if (selectBoxParagraph) {
        selectBoxParagraph.classList.remove('form-field--invalid');
      }
    } else {
      this.showConfirmationEl(this.formData.get('senderEmail'), true);
    }
  }
}
